import { TextField } from '@eleveo/components-react';
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useIntegrations } from '../../../app/IntegrationsProvider';
import { TEST_IDS } from '../../../constants/dataTestIds';
import { INTEGRATION_FORM_FIELDS } from '../../../scene/integrations/types';
import { composeValidators } from '../../../utils/validations/composeValidators';
import { max10000Chars } from '../../../utils/validations/max10000Chars';
import { handleMaxCharsError } from '../../../utils/validations/maxChars';
import { required } from '../../../utils/validations/required';

export const FieldClientId: React.FC = () => {
  const { t } = useTranslation();
  const { isInReadOnlyMode, integrationType } = useIntegrations();

  return (
    <Field name={INTEGRATION_FORM_FIELDS.id(integrationType)} validate={composeValidators(required, max10000Chars)}>
      {({ input, meta }) => (
        <TextField
          isRequired
          isReadOnly={isInReadOnlyMode}
          label={t('myConfigurations.configuration.clientId')}
          className="w-full"
          validationState={meta.touched && meta.invalid ? 'invalid' : 'valid'}
          errorMessage={handleMaxCharsError(meta.error, t, 10000)}
          {...input}
          testId={TEST_IDS.inputClientId}
        />
      )}
    </Field>
  );
};
